import { Select } from 'antd'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useGetServicesQuery } from '../redux/apis/servicesManagement/sMServicesApiSlice'

const ServicesAliasDropdown = ({
  onChange,
  onBlur,
  value,
  service_type,
  service_category,
  service_category_name,
  sub_category,
  disabled,
  className,
  isAll = false,
  mode,
  label="Service"
}) => {
  const { data, isLoading, error } = useGetServicesQuery({
    fields: ['id', 'service_alias'],
    page: '*',
    service_type: service_type,
    service_category: service_category,
    sub_category:sub_category,
    service_category_name:service_category_name,
    is_active:true
  })

  let options

  if (data) {
    const seen = new Set()
    options = data?.data?.results
      ?.filter(x => {
        if (seen.has(x.service_alias)) {
          return false
        }
        seen.add(x.service_alias)
        return true
      })
      .map(x => {
        return { label: x.service_alias, value: x.service_alias }
      })
    if (isAll) {
      options = [{ label: 'All Services', value: '10000' }, ...options]
    }
  }
  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  return (
    <div className=' mb-3 flex-1'>
      <label className='form-label'>{label}</label>
      <br />
      <Select
        className={className}
        name='service'
        placeholder='Select a service'
        showSearch
        mode={mode}
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={options}
        disabled={disabled}
      />
    </div>
  )
}

export default ServicesAliasDropdown
